import React from "react";
import { useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { StoreState } from "../../store/reducers";

const HelpScreen = () => {

    const helpDocument = useSelector((state: StoreState) => state.helpDocument);

    if (!helpDocument) {
        return null;
    }

    return (<div className="markdown-styles"><ReactMarkdown children={helpDocument} remarkPlugins={[remarkGfm]} /></div>)
}

export default HelpScreen;
